module.exports = __webpack_public_path__ + "assets/add.96299cd0.svg";